import { jsx as _jsx } from "react/jsx-runtime";
import Icon from '@ant-design/icons';
const svgDir = require.context('./', true, /\.svg$/);
export const SvgIcon = ({ name, size, ...svgProps }) => {
    const path = `./${name}.svg`;
    const Component = svgDir(path).default;
    return _jsx(Icon, { component: () => _jsx(Component, { ...svgProps, fontSize: size }) });
};
